import { render, staticRenderFns } from "./PrintBarCodeOnShelf.vue?vue&type=template&id=23029b92&scoped=true&"
import script from "./PrintBarCodeOnShelf.vue?vue&type=script&lang=js&"
export * from "./PrintBarCodeOnShelf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23029b92",
  null
  
)

export default component.exports